import { render } from "./Footer.vue?vue&type=template&id=1d6a4d8c"
import script from "./Footer.js?vue&type=script&lang=js"
export * from "./Footer.js?vue&type=script&lang=js"

import "./Footer.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__